module.exports = __webpack_public_path__ + "img/laser.d284b650.jpg";